$('.testimonial-carousel').owlCarousel({
    margin: 40,
    loop: true,
    nav: false,
    dots: true,
    responsive: {
        992: {
            items: 1,
        },
        0: {
            items: 1,
        }
    },
});